// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"NavBreadcrumbs_breadcrumbs__6hbBY"};